import * as api from "./api";
import * as modelsGet from "../models/get";

export function getSubscription(id: number): JQueryPromise<modelsGet.ISubscription>
{
    var endpoint = new URI("api/subscriptions");
    endpoint.segment(id.toString());

    return api.get<modelsGet.ISubscription>({
        endpoint: endpoint.href()
    });
}

export function getSubscriptions(): JQueryPromise<modelsGet.ISubscription[]>
{
    var endpoint = new URI("api/subscriptions");

    return api.get<modelsGet.ISubscription[]>({
        endpoint: endpoint.href()
    });
}

export function post(sub: modelsGet.ISubscription): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/subscriptions",
        data: JSON.stringify(sub)
    });
}

export function put(id: number, sub: modelsGet.ISubscription): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/subscriptions/${id}`,
        data: JSON.stringify(sub)
    });
}

export function putCancel(id: number, sub: modelsGet.ISubscriptionSubscriber): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/subscriptions/${id}/cancel`,
        data: JSON.stringify(sub)
    });
}

export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/subscriptions/${id}`
    });
}